import _regeneratorRuntime from "/nerv.app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/nerv.app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.index-of.js";
import { loginApi } from "./utils/api";
import { getTimeZoneInfo } from "./utils/native";

window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
};

export default {
  name: "App",
  data: function data() {
    return {
      loaded: false,
      timeZone: '',
      isIos: false,
      isCn: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var lang, u, isiOS;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log('app 页面created')
              lang = (navigator.language || "").toLowerCase();
              _this.isCn = lang === "zh-CN".toLowerCase() || lang === "zh-TW".toLowerCase();

              window.setSleepData = function (mode, year, month, day) {
                _this.goRoute(mode, year, month, day);
              };

              u = navigator.userAgent;
              isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

              sessionStorage.setItem('isiOS', isiOS);
              _this.isIos = isiOS;
              _context.next = 9;
              return getTimeZoneInfo();

            case 9:
              _this.timeZone = _context.sent;

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  watch: {
    '$route': {
      handler: function handler(route, oldRoute) {
        // version: 版本 ios数字， 安卓非全数字
        // 开发调试使用，上线时需要屏蔽
        // route.query={
        //     token: "9541fbf8c3aa2ba20309fd9773d92a2e",
        //     sign: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NjgzMDY3ODcsInVzZXJJZCI6IjIiLCJpYXQiOjE2NjU3MTQ3ODd9.9O-MHFfTkMS4RBsY_Zc7TT5rFzb3Qfo_mSqC8E9_gNU",
        //     source: 1,
        //     version: "1.0.1",
        //     platform: 2,
        //     oversea: 1,
        //     theme: 'dark'
        // }
        if (!route.name) {} else if (JSON.stringify(route.query) === '{}') {
          //console.log('入口监听route变化', route, oldRoute)
          var search = window.location.search;
          console.log('入口监听route变化11111', search);

          if (search) {
            var query = this.getRequest(search);
            this.setQueryStorage(query);
          } else {
            this.loaded = true;
          }
        } else {
          // console.log('入口监听route变化', route, oldRoute)
          console.log('入口监听route变化22222', route.query);
          this.setQueryStorage(route.query);
        }
      },
      immediate: true,
      deep: true
    }
  },
  provide: function provide() {
    return {
      isChina: true
    };
  },
  methods: {
    getRequest: function getRequest(urlStr) {
      var url;

      if (typeof urlStr == "undefined") {
        url = decodeURI(location.search); //获取url中"?"符后的字符串
      } else {
        url = "?" + urlStr.split("?")[1];
      }

      var theRequest = new Object();

      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");

        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }

      return theRequest;
    },
    setQueryStorage: function setQueryStorage(query) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (query.token) {
                  localStorage.setItem('token', query.token);
                }

                if (!query.timeZone) {
                  _context2.next = 5;
                  break;
                }

                localStorage.setItem('timeZone', query.timeZone);
                _context2.next = 9;
                break;

              case 5:
                _context2.next = 7;
                return getTimeZoneInfo();

              case 7:
                _this2.timeZone = _context2.sent;
                localStorage.setItem('timeZone', _this2.timeZone);

              case 9:
                if (query.wwid) {
                  localStorage.setItem('wwid', query.wwid);
                }

                if (query.oversea) {
                  localStorage.setItem('oversea', query.oversea);
                }

                if (query.source) {
                  //1：VPA 2：wear3
                  localStorage.setItem('source', query.source);
                }

                if (query.version) {
                  //版本号
                  localStorage.setItem('version', query.version);
                }

                if (query.theme === 'dark') {
                  document.documentElement.className = "dark";
                  window.theme = "dark";
                } else {
                  window.theme = "light";
                }

                if (query.sign) {
                  localStorage.setItem('sign', query.sign);
                  _this2.loaded = true;
                } else {
                  _this2.loaded = false;

                  _this2.getSign();
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getSign: function getSign() {
      var _this3 = this;

      if (localStorage.getItem('wwid') && localStorage.getItem('token')) {
        var data = {
          overseaVersion: localStorage.getItem('oversea'),
          platform: sessionStorage.getItem('isiOS') === 'true' ? 0 : 1,
          timeZone: localStorage.getItem('timeZone'),
          token: localStorage.getItem('token'),
          wwid: localStorage.getItem('wwid')
        };
        loginApi(data).then(function (res) {
          // console.log(res)
          _this3.loaded = true;

          if (res) {
            localStorage.setItem('sign', res.sign);
          }
        }).catch(function (e) {
          _this3.loaded = true; // console.log('登录报错', e)
        });
      } else {
        this.loaded = true;
      }
    },
    goRoute: function goRoute(mode, year, month, day) {
      this.$router.push({
        name: "sleep",
        params: {
          year: year,
          month: month,
          day: day
        },
        query: {
          mode: mode
        }
      });
    }
  }
};